import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { StickyTabNav } from '@synoptic/ui-kit/tab-nav/sticky-tab-nav.js';
import { Suspense } from 'react';
import { Outlet, useSearchParams } from 'react-router';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { StripeDetailsSubmittedModal } from '@/components/stripe-account/stripe-details-submitted-modal.tsx';
import { TabLink } from '@/components/tab-link.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { StreamFilters } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-filters.tsx';
import { StreamStateFilter } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-state-filter.tsx';
import {
  StreamHeaderActions,
  StreamHeaderFilters,
} from '@/routes/_app.p.marketplace.streams/streams-header/streams-header.tsx';
import { marketplaceOutletNav } from '@/routes/_app.p.marketplace/page.css.ts';

export const ErrorBoundary = ErrorPage;

export const handle = {
  description: () =>
    'Custom streams enable users to define the data they want to track. ' +
    'Provide your own targets, and the stream will monitor them, ' +
    'delivering real-time updates tailored to your needs.',
  titleAside: () => <StreamHeaderActions />,
  filters: () => <StreamHeaderFilters />,
  children: () => (
    <StripeDetailsSubmittedModal
      redirectTo={OnboardingLinkPage.CustomStreams}
    />
  ),
};

export default function CustomStreams() {
  const [searchParams] = useSearchParams();
  const isSearchActive = searchParams.get('q');
  const isTablet = useIsTablet();

  return (
    <>
      {!isSearchActive && (
        <>
          <StickyTabNav
            className={marketplaceOutletNav}
            size={isTablet ? 'large' : 'small'}
          >
            <TabLink end to={paths.customStreams}>
              All streams
            </TabLink>

            <TabLink to={paths.customStreamsFollowing}>Following</TabLink>

            <TabLink to={paths.customStreamsCreated}>
              Streams you created
            </TabLink>
          </StickyTabNav>

          <StreamFilters>
            <StreamStateFilter />
          </StreamFilters>
        </>
      )}

      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </>
  );
}
